// extracted by mini-css-extract-plugin
export default {"logo":"layout_logo__ZmQyO"};